const themeUi = require('theme-ui')
const react = require('react')

const defaultBreakpoints = [300, 600, 900, 1300]

const useBreakpointIndex = function (options = {}) {
  const context = themeUi.useThemeUI()
  let { defaultIndex = 0 } = options
  const breakpoints = (context.theme && context.theme.breakpoints) || defaultBreakpoints

  if (typeof defaultIndex !== 'number') {
    throw new TypeError(
      `Default breakpoint index should be a number. Got: ${defaultIndex}, ${typeof defaultIndex}`
    )
  } else if (defaultIndex < 0 || defaultIndex > breakpoints.length - 1) {
    throw new RangeError(
      `Default breakpoint index out of range. Theme has ${breakpoints.length} breakpoints, got index ${defaultIndex}`
    )
  }

  const [value, setValue] = react.useState(null)
  react.useEffect(() => {
    const getIndex = () =>
      breakpoints.filter(
        (bp) => window.matchMedia(`screen and (min-width: ${bp})`).matches
      ).length

    const onResize = () => {
      const newValue = getIndex()
      if (value !== newValue) {
        setValue(newValue)
      }
    }

    onResize();

    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [breakpoints, value])

return value
}

const useResponsiveValue = (values, options = {}) => {
  const array = values
  const index = useBreakpointIndex()
  const val = index >= array.length ? array.length - 1 : index
  return val === undefined ? null : array[val]
}

export { useResponsiveValue, useBreakpointIndex }


